import { Box, Button, TextField } from '@mui/material'
import { showPerPageName } from 'config/globalVariables'
import { useAlert } from 'context/AlertContext'
import { useEffect, useState } from 'react'

export const DefaultPerPage = () => {
  const [perPage, setPerPage] = useState(100)
  const { changeMessage } = useAlert()

  useEffect(() => {
    const localStorageData = localStorage.getItem(showPerPageName)

    if (localStorageData) {
      setPerPage(+localStorageData)
    }
  }, [])

  const handleChangeValue = (val: string) => {
    const newValue = Number(val)

    if (!Number.isNaN(newValue)) {
      setPerPage(newValue)
    }
  }

  const handleSave = () => {
    localStorage.setItem(showPerPageName, `${perPage}`)
    changeMessage('Show per page value updated', 'success')
  }

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <TextField
        label="Default show per page"
        value={perPage}
        type="number"
        onChange={e => {
          handleChangeValue(e.target.value)
        }}
      />
      <Button onClick={handleSave}>Save</Button>
    </Box>
  )
}
